import { createContext, type Dispatch, type SetStateAction } from 'react';
import type { ComplianceDocument } from '@/app/types';

/** Defines the shape of the context data */
interface DocumentsContextType {
  documentsCP: ComplianceDocument[];
  currentDocument?: ComplianceDocument;
  setCurrent: Dispatch<SetStateAction<ComplianceDocument | undefined>>;
  setDocuments: Dispatch<SetStateAction<ComplianceDocument[]>>;
}

/** Initial empty document list */
export const initDocument: ComplianceDocument[] = [];

/** Default context value */
const defaultValue: DocumentsContextType = {
  documentsCP: initDocument,
  currentDocument: undefined,
  setCurrent: () => {
    // intentionally empty
  },
  setDocuments: () => {
    // intentionally empty
  }
};

/** Documents context shared across the app */
export const DocumentContext =
  createContext<DocumentsContextType>(defaultValue);
